export const LOGOUT_API='api/logout';
export const CHANGE_MY_PASSWORD='api/change-my-password';
export const CHANGE_STAKE_VALUES='api/change-stake-values'
export const FEEDBACK_API='api/user-feedback'
export const WALLET_LIMITS='api/wallet-limits';